import React from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import MembersApi from "../../../../services/portal-api/MembersApi";
import Pagination from 'react-js-pagination';
import TextInput from '../../../../components/Form/components/TextInput';
import AuthService from '../../../../services/AuthService';

export default class StoreTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deleted: false,
            selectedStore: '',
        }
    }

    handlePageChange = (pageNumber) => {
        this.props.handlePageChange(pageNumber);
    };

    handleStoreChange = (event) => {
        const value = event.target.value;
        this.setState({
            selectedStore: value
        });
        this.props.searchStore(value);
    }

    handleInputs = (id) => {
        // if (window.confirm("Do you really want to Delete this Store and it's accounts ?")) {
        //     MembersApi.delStoreAndUsers((response) => {
        //         if (response.success) {
        //             alert(response.json.message);
        //             this.props.removeStore(id);
        //             this.setState({
        //                 deleted: true,
        //             });
        //         } else {
        //             this.props.sessionLog(response);
        //         }
        //     }, id);
        // }

        swal({
            title: "Are you sure?",
            text: "you really want to delete this store and it's user accounts ?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    MembersApi.delStoreAndUsers((response) => {
                        if (response.success) {
                            this.props.removeStore(id);
                            swal(response.json.message, {
                                icon: "success",
                                buttons: false,
                                timer: 3000
                            });
                            this.setState({
                                deleted: true,
                            });
                        } else {
                            this.props.sessionLog(response);
                        }
                    }, id);
                } else {
                    swal(`You have cancelled the delete action`, {
                        buttons: false,
                        timer: 2000
                    });
                }
            });
    }

    render() {
        const paginationStyles = {
            display: 'flex',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            marginTop: '10px',
        };

        const rows = [];
        let k = 0;

        let displayedStores = [];
        let filteredLength = 1;

        if (this.props.isFiltering) {
            displayedStores = this.props.filteredStates;
            filteredLength = displayedStores.length == 0 ? filteredLength : displayedStores.length;
        } else {
            displayedStores = this.props.paginatedStates;
        }

        displayedStores.forEach((store, index) => {
            let ip = '';
            if (store.primary_ip != '') {
                const parsedIp = JSON.parse(store.primary_ip);
                if (Array.isArray(parsedIp)) {
                    ip = parsedIp.join(', ');
                }
            }
            rows.push(
                <tr key={index}>
                    <td><strong>{store.name}</strong></td>
                    <td>{store.suburb}</td>
                    <td>{store.postcode}</td>
                    <td>{store.state}</td>
                    <td>{ip}</td>
                    <td>
                        <table style={{ marginTop: 0 }}>
                            <tbody>
                                <tr>
                                    {AuthService.can('Edit stores') &&
                                        <td style={{ border: 0, background: "transparent", textAlign: "right" }}><Link to={{ 'pathname': '/new-store/' + store.id + '/edit/' + store.suburb, }} className="btn btn--xsmall btn--green btn--open">Edit <img className="icon" src="/img/icon-arrowOpen--white.svg" width="10" height="10" /></Link></td>
                                    }
                                    {AuthService.can('Delete stores') &&
                                        <td style={{ border: 0, background: "transparent" }}><a href="javascript:void(0)" className="btn btn--xsmall btn--red" onClick={this.handleInputs.bind(this, store.id)} >Remove</a></td>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            );
        });

        return (
            AuthService.can('view stores') &&
            <div className="container container--wide padding--40">
                <h2 className="text--light text--color text--40">Stores</h2>
                <div className="table--overflow clearfix margin--30--top" style={{ overflow: "auto" }}>
                    <div className="col">
                        <div className="col">
                            <TextInput
                                name="store"
                                label="Search by store name, state, suburb or postcode"
                                value={this.state.selectedStore}
                                onChange={this.handleStoreChange}
                            />
                        </div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Store Name</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Suburb</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Postcode</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>State</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>IP</th>
                                <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top', textAlign: 'center' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows}
                            {rows.length === 0 &&
                                <tr>
                                    <td colSpan="6">No results founds.</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                    {this.props.totalStates >= 51 &&
                        <div style={paginationStyles}>
                            <nav>
                                <Pagination
                                    activePage={this.props.currentPage}
                                    itemsCountPerPage={50}
                                    totalItemsCount={this.props.isFiltering ? filteredLength : this.props.totalStates}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange}
                                    innerClass="pagination"
                                />
                            </nav>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

StoreTable.propTypes = {
    paginatedStates: PropTypes.array.isRequired
};